module.exports = __webpack_public_path__ + "static/img/1017_small.2e054db.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1017_small.png
// module id = 00uQ
// module chunks = 1